<template>
    <WindowAbstract class="window-base">

        <div class="window-base__header">
            <div class="window-base__header-button left"></div>
            <div class="window-base__header-heading">
                {{ heading }}
            </div>
            <div class="window-base__header-button right">
                <v-tooltip
					location="bottom"
					text="close this window">
					<template v-slot:activator="{ props }">
                        <v-btn 
                            variant="plain" 
                            elevation="0" 
                            v-bind="props" 
                            @click="handleClose">
                            <v-icon icon="fa-solid fa-xmark" />
                        </v-btn>
                    </template>
                </v-tooltip>
            </div>
        </div>

        <div class="window-base__content">
            <slot></slot>
        </div>

        <div class="window-base__actions">
            <v-btn 
                v-for="(action, index) in actions" 
                :key="index" 
                :color="action.color || 'primary'" 
                :variant="action.variant || 'tonal'" 
                :disabled="action.disabled || false"
                @click="action.handler">
                {{ action.label }}
            </v-btn>
        </div>

    </WindowAbstract>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import WindowAbstract from './WindowAbstract.vue'

export default {
    name: 'WindowBase',
    components: {
        WindowAbstract
    },
    props: {
        heading: {
            type: String,
            default: ''
        },  
        actions: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        ...mapActions('windows', [
            'close'
        ]),
        handleClose() {
            this.close()
        }
    }
}
</script>

<style scoped>
.window-base {
    display: flex;
    flex-direction: column;
}

.window-base__header {
	position: relative;
	width: 100%;
	min-height: 65px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1.7rem;
	border-bottom: 1px solid rgb(var(--v-theme-lightbase));
    background-color: rgb(var(--v-theme-darkbase));
	user-select: none;
}

.window-base__header-button {
	min-width: 74px;
}

.window-base__header-button .v-btn {
	min-height: 65px;
	min-width: 74px;
	border-radius: 0px !important;
}

.window-base__header-button .v-btn .v-icon {
	font-size: 1.5rem;
	color: rgb(var(--v-theme-secondary));
}

.window-base__header-heading {
    flex-grow: 1;
	display: flex;
	justify-content: center;
	align-items: center;
}

.window-base__header-button.right {
	justify-content: flex-end;
}

.window-base__header-button.right .v-btn:hover {
	background-color: rgba(var(--v-theme-error), 0.3) !important;
}

.window-base__content {
	position: relative;
    flex: 1;
    background: linear-gradient(
		rgba(var(--v-theme-darkerbase), 0.3) 0%,
		rgba(var(--v-theme-darkerbase), 0.5) 50%,
		rgba(var(--v-theme-darkerbase), 0.3) 100%
	);
    overflow: hidden;
}

.window-base__actions {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5px;
    padding: 0 20px;
    border-top: 1px solid rgb(var(--v-theme-lightbase));
    background-color: rgb(var(--v-theme-darkbase));
}

@media (max-width: 1600px) {
	.window-base__header {
		min-height: 60px;
	}
}

@media (max-width: 1000px) {
	.window-base__header-button {
		min-width: 60px;
	}

	.window-base__header-button.fullscreen {
		min-width: 120px;
	}

	.window-base__header-button .v-btn {
		max-height: 40px;
		max-width: 40px;
	}
}

@media (max-width: 800px) {
	.window-base__header {
		font-size: 1.3rem;
	}

	.window-base__header-heading {
		padding-left: 10px;
	}

	.window-base__header-button {
		min-width: 45px;
	}

	.window-base__header-button.fullscreen {
		min-width: 45px;
	}

	.window-base__header-button .v-btn {
		max-height: 35px;
		max-width: 35px;
	}
}

@media (max-width: 600px) {
	.window-base__header {
		min-height: 55px;
		max-height: 55px;
		font-size: 1.3rem;
	}

	.window-base__header-button.right .v-btn {
		min-height: 55px;
		max-height: 55px;
	}
}

@media (max-width: 450px) {
	.window-base__header-heading {
		padding-left: 20px;
		justify-content: flex-start;
		font-size: 1.0rem;
	}

	.window-base__header-button.left {
		display: none;
	}

	.window-base__header-button.right {
		height: 100%;
	}

	.window-base__header-button.right .v-btn {
		min-height: 55px;
		max-height: 55px;
		max-width: unset;
		height: 100%;
	}
}
</style>